var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosicao3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 79,
    viewBox: "0 0 86 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 58.8418,
    width: 86,
    height: 20,
    fill: "url(#paint0_linear_342_28033)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5879 11.4331L30.9664 15.4108L25 3.9786L32.6214 0.000976562L38.5879 11.4331Z",
    fill: "#5C1526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5976 12.9937L34.1475 13.7505L28.181 2.31835L29.6312 1.56152L35.5976 12.9937Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5879 11.4336L56.2093 15.4112L62.1757 3.97905L54.5543 0.00142097L48.5879 11.4336Z",
    fill: "#5C1526"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5781 12.9941L53.0282 13.751L58.9947 2.3188L57.5445 1.56197L51.5781 12.9941Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7455 28.8737C60.7455 38.7445 52.7436 46.7464 42.8727 46.7464C33.0019 46.7464 25 38.7445 25 28.8737C25 19.0029 33.0019 11.001 42.8727 11.001C52.7436 11.001 60.7455 19.0029 60.7455 28.8737Z",
    fill: "url(#paint1_linear_342_28033)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7455 28.8737C62.7455 39.8491 53.8481 48.7464 42.8727 48.7464C31.8973 48.7464 23 39.8491 23 28.8737C23 17.8983 31.8973 9.00098 42.8727 9.00098C53.8481 9.00098 62.7455 17.8983 62.7455 28.8737ZM42.8727 46.7464C52.7436 46.7464 60.7455 38.7445 60.7455 28.8737C60.7455 19.0029 52.7436 11.001 42.8727 11.001C33.0019 11.001 25 19.0029 25 28.8737C25 38.7445 33.0019 46.7464 42.8727 46.7464Z",
    fill: "#9A4609"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8727 44.7464C51.639 44.7464 58.7455 37.64 58.7455 28.8737C58.7455 20.1074 51.639 13.001 42.8727 13.001C34.1065 13.001 27 20.1074 27 28.8737C27 37.64 34.1065 44.7464 42.8727 44.7464ZM42.8727 46.7464C52.7436 46.7464 60.7455 38.7445 60.7455 28.8737C60.7455 19.0029 52.7436 11.001 42.8727 11.001C33.0019 11.001 25 19.0029 25 28.8737C25 38.7445 33.0019 46.7464 42.8727 46.7464Z",
    fill: "#D86100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.999 28.3447C44.9788 28.5042 45.4688 29.2038 45.4688 30.4434V32.7949C45.4688 33.6243 45.2044 34.2806 44.6758 34.7637C44.1517 35.2422 43.4043 35.4814 42.4336 35.4814C40.4193 35.4814 39.4121 34.5062 39.4121 32.5557V29.9238H41.75V32.7812C41.75 33.0228 41.8092 33.2096 41.9277 33.3418C42.0508 33.474 42.2103 33.54 42.4062 33.54C42.8255 33.54 43.0352 33.2552 43.0352 32.6855V30.2451C43.0352 29.9079 42.9714 29.6709 42.8438 29.5342C42.7207 29.3929 42.527 29.3223 42.2627 29.3223H41.0596L40.7246 27.5312H42.208C42.4951 27.5312 42.6888 27.4606 42.7891 27.3193C42.8893 27.1735 42.9395 26.9502 42.9395 26.6494V24.6602C42.9395 24.4368 42.8848 24.2637 42.7754 24.1406C42.6706 24.013 42.5293 23.9492 42.3516 23.9492C42.1556 23.9492 42.0007 24.0153 41.8867 24.1475C41.7773 24.2751 41.7227 24.4551 41.7227 24.6875V26.998H39.4258V24.6875C39.4258 23.8307 39.681 23.1699 40.1914 22.7051C40.7064 22.2357 41.472 22.001 42.4883 22.001C43.3451 22.001 44.0355 22.2197 44.5596 22.6572C45.0837 23.0902 45.3457 23.6735 45.3457 24.4072V26.2324C45.3457 26.8021 45.2454 27.2487 45.0449 27.5723C44.8444 27.8913 44.4958 28.1169 43.999 28.249V28.3447Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_342_28033",
    x1: 43,
    y1: 58.8418,
    x2: 43,
    y2: 78.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F1221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_342_28033",
    x1: 42.8727,
    y1: 0.000976563,
    x2: 42.8727,
    y2: 48.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4792F"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosicao3);
export default __webpack_public_path__ + "static/media/posicao-3.0e938e6b5134e185b191076bcf8382d7.svg";
export { ForwardRef as ReactComponent };